import { IFSMState, IFSMTransition } from '@src/slide/infrastructure/module/independent/state-machine/state-machine.interface';

export default class FSMTransition implements IFSMTransition {
    public event: string;
    public from: IFSMState;
    public to: IFSMState;
    public onTransition;

    public constructor(event: string, from: IFSMState, to: IFSMState) {
        this.event = event;
        this.from = from;
        this.to = to;
    }

    public transitionCallback(): boolean {
        if (this.onTransition) {
            return this.onTransition();
        }
        return false;
    }
}
